<template>
    <h5>Company Performance as of {{ today }}</h5>
    <DataTable :value="companyPerformance" showGridlines tableStyle="min-width: 50rem">
        <Column header="Fund" class="leftHeader">
            <template #body="slotProps">
                {{ slotProps.data.fund }}
            </template>
        </Column>
        <Column header="Investment Date">
            <template #body="slotProps">
                {{ slotProps.data.investmentDate == null ? '' : new Date(slotProps.data.investmentDate).toLocaleDateString('en-us') }}
            </template>
        </Column>
        <Column header="Cost">
            <template #body="slotProps">
                {{ slotProps.data.cost == null ? '' : formatCurrencyKeepCents(slotProps.data.cost) }}
            </template>
        </Column>
        <Column header="Pay Out">
            <template #body="slotProps">
                {{ slotProps.data.payout == null ? '' : formatCurrencyKeepCents(slotProps.data.payout) }}
            </template>
        </Column>
        <Column header="NET">
            <template #body="slotProps">
                {{ slotProps.data.net == null ? '' : formatCurrencyKeepCents(slotProps.data.net) }}
            </template>
        </Column>
        <Column header="FMV">
            <template #body="slotProps">
                {{ slotProps.data.fmv == null ? '' : formatCurrencyKeepCents(slotProps.data.fmv) }}
            </template>
        </Column>
        <Column header="% Change">
            <template #body="slotProps">
                {{ slotProps.data.percentChange == null ? '' : slotProps.data.percentChange.toFixed(2) + '%' }}
            </template>
        </Column>
        <Column header="Total">
            <template #body="slotProps">
                {{ slotProps.data.total == null ? '' : formatCurrencyKeepCents(slotProps.data.total) }}
            </template>
        </Column>
    </DataTable>
</template>

<script>
    export default {
        name: 'CompanyPerformance',
        props: ['companyPerformance'],
        data () {
            return {
                today: null
            }
        },
        methods: {
            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
            },
            formatCurrencyKeepCents(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                // Then specify how you want your dates to be formatted
                return new Intl.DateTimeFormat('default', {dateStyle: 'long'}).format(date);
            },
            formatTwoDecimal(num) {
                return parseFloat(num).toFixed(2);
            },
            isLastDay(dt) {
                var test = new Date(dt.getTime()),
                    month = test.getMonth();

                test.setDate(test.getDate() + 1);
                return test.getMonth() !== month;
            }
        },
        async mounted () {
            var d = new Date();
            this.today = d.toLocaleDateString('en-us', {year: 'numeric', month: 'long', day: 'numeric'});
        }

    }

</script>